export enum WebsocketAction {
  CREATE = 'create',
  UPDATE = 'update',
  DELETE = 'delete',
  RESET = 'reset',
  RESET_DELETE = 'reset_delete',
  UPDPATE_RESERVATION = 'update_reservation',
  UPDATE_STATUS = 'update_status',
}

export interface WebsocketMessage {
  action: WebsocketAction;
  data: any;
  deviceId: string;
  service: string;
  date: string;
}
